import {  useContext, useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate, useParams } from "react-router-dom";
import Modal from "../Components/Modal";
import UserProfileButton from "../Components/UserProfileButton";
import UserContext from "../Context/UserContext";
import { getExhibitorsDoc, updateUserDoc } from "../Requests/firebaseFirestore";
import './Styles/InfoPage.css'
import {IoInformationCircleSharp} from 'react-icons/io5'
import Spinner from "../Components/Spinner";
import { useTranslation } from "react-i18next";


export default function InfoPage (){
  const navigate = useNavigate()
  const {t} = useTranslation()
  const {role} = useParams()
  const {user, seeAs, setSeeAs} = useContext(UserContext)
  const [loading, setLoading] = useState(true)
  const [buttons, setButtons] = useState('')
  const [showSeeAsModal, setShowSeeAsModal] = useState(false)
  const location = useLocation()
  const [exhibitors, setExibitors] = useState([])
  const [seeAsInput, setSeeAsInput] = useState('')
  const [infoModal, setInfoModal] = useState(false)
  const [newInfo, setNewInfo] = useState({})

  const handleInfoSubmit = async (e) => {
    e.preventDefault()
    await updateUserDoc(user.uid, newInfo)
    setInfoModal(false)
  }

  useEffect(()=>{
    document.body.className = document.body.className = 'bg-white'
    if(document.getElementsByClassName('nav-button')){                //nav buttons foolery
      Array.prototype.map.call(document.getElementsByClassName('nav-button'), (btn)=>{
        if (btn.id===location.pathname.slice(location.pathname.lastIndexOf('/')+1,)) {
          btn.classList.value='nav-button active-nav'
        } else {
          btn.classList='nav-button'
        }
      })
    }
  })
  const handleSeeAs = (e) => {
    e.preventDefault()
    setSeeAs(JSON.parse(seeAsInput))
    handleModal()
    navigate('/exhibitor')
  }

  useEffect(()=>{
    if(role==='exhibitor' && user.role === 'organizer' && seeAs === ''){
      navigate(`/${user.role}`)
    }
  }, [navigate, user, seeAs, role])
  
  useEffect(()=>{
    if(user.role&&user.role!=='organizer'){
      if(!user.position || !user.phone){
        setInfoModal(true)
      }
    }
  },[user])

  useEffect(()=>{
    if(user === false){
      navigate('/signin')
    }
  },[user, navigate])
  useEffect(()=>{
    if(user!=='checking'){
      switch (role){
        case 'organizer':
          if(user.role!=='organizer'){
            navigate(`/${user.role}`)
          }else{
            if(location.pathname==='/organizer'){
              navigate('/organizer/events')
            }
            setButtons(
              <>
              <button className='nav-button' id='events' onClick={()=>{navigate('/organizer/events')}}>{t('events')}</button>
              <button className='nav-button' id='exhibitors' onClick={()=>{navigate('/organizer/exhibitors')}}>{t('exhibitors')}</button>
              <button className='nav-button' id='groups' onClick={()=>{navigate('/organizer/groups')}}>{t('groups')}</button>
              <button className='nav-button' id='guests' onClick={()=>{navigate('/organizer/guests')}}>{t('guests')}</button>
              <button className='nav-button' id='users' onClick={()=>{navigate('/organizer/users')}}>{t('users')}</button>
              <button className='nav-button' id='staff' onClick={()=>{navigate('/organizer/staff')}}>{t('organizers')}</button>
              </>
            )
            setSeeAs('')
          }
          break;
          case 'exhibitor':
            if(user.role==='organizer'||user.role==='exhibitor'){
              if(location.pathname==='/exhibitor'){
                navigate('/exhibitor/events')
              }
              setButtons(
                <>
                <button className='nav-button' id='events' onClick={()=>{navigate('/exhibitor/events')}}>{t('events')}</button>
                <button className="nav-button" id="groups" onClick={()=>{navigate('/exhibitor/groups')}}>{t('groups')}</button>
                <button className="nav-button" id="invite" onClick={()=>{navigate('/exhibitor/invite')}}>{t('inviteClients')}</button>
                <button className="nav-button" id="staff" onClick={()=>{navigate('/exhibitor/staff')}}>{t('staff')}</button>
                </>
              )
            }else{
              navigate(`/${user.role}`)
            }
            break;
            case 'staff':
              if(user.role!=='staff'){
                navigate(`/${user.role}`)
              }else{
                if(location.pathname ==='/staff'){
                  navigate('/staff/groups')
                }
                setButtons(<>
                <button className="nav-button" id="groups" onClick={()=>{navigate('/staff/groups')}}>{t('groups')}</button>
                <button className="nav-button" id="invite" onClick={()=>{navigate('/staff/invite')}}>{t('inviteClients')}</button>
                </>)
              }
              break;
              default:
          if(user.role){
            navigate(`/${user.role}`)
          }else{
            navigate('/')
          }
          break;
        }
        
      setLoading(false)
    }
  },[user, navigate, role, showSeeAsModal, setSeeAs , location])

  const handleModal = async ()=>{
    if(exhibitors.length===0){
      const res = await getExhibitorsDoc()
      setExibitors(res.sort((a,b) => (a.company > b.company) ? 1 : ((b.company > a.company) ? -1 : 0))
      )
    }
    setShowSeeAsModal(!showSeeAsModal)
  }

  return(<>
    <nav className="flex flex-wrap py-4 px-6 items-center gap-2 gap-y-4 border-b-stone-300 border justify-around">
      <div className="flex">
        <img className="w-[175px] mx-auto lg:ml-0 lg:mr-auto cursor-pointer" onClick={()=>{navigate('/')}} alt='Channel Talks logo' src={require('../Assets/channeltalks-color.png')}/>
      </div>
      <div className="flex flex-wrap gap-3 justify-center text-stone-500 mx-auto">
        {buttons}
      </div>
      {user!=='checking'?<>
      <div className="flex flex-wrap justify-center items-center gap-2 mx-auto lg:mx-0">
        {user.role==='organizer'
        ?<>{
        seeAs===''?
          <button className='text-[#F03623] border border-[#F03623] rounded-[10px] py-2 px-3 hover:text-white hover:bg-[#F03623] duration-200 min-w-fit'onClick={()=>{handleModal()}}>{t('seeAsExh')}</button>
        :
        <button className='text-[#F03623] border border-[#F03623] rounded-[10px] py-2 px-3 hover:text-white hover:bg-[#F03623] duration-200 min-w-fit'onClick={()=>{navigate('/organizer')}}>{t('seeAsOrg')}</button>
        }</>
        :<></>
        }
          <UserProfileButton imageUrl={user.photoURL} userName={user.fullName}/>
      </div>
      </>:<></>}
    </nav>
    {loading?
    <div className="text-black py-5">
      <Spinner/>
    </div>
    :
      <>
      {seeAs!==''&&user.role==='organizer'?
      <div className="container mx-auto">
        <h1 className=" py-2 px-3 border border-stone-500 bg-stone-200 w-fit mx-auto mt-5 rounded-[10px] flex gap-2"><IoInformationCircleSharp size={25} className='text-stone-600'/> {t('seeingAs')} {seeAs.fullName} ({seeAs.company})</h1>
      </div>
      :<></>}
      <Outlet/>
      <Modal isActive={showSeeAsModal} handle={handleModal} title={t('seeAsExh')}>
        <form  className='flex flex-col gap-4' onSubmit={handleSeeAs}>
          <div className="input-holder w-[75%]">
            <select id="new-group-event" onChange={(e)=>{setSeeAsInput(e.target.value)}} name='event' value={seeAsInput} required>
            <option value="" disabled hidden></option>
              {exhibitors.map((exhibitor, index)=>{return(<option key={index} value={JSON.stringify(exhibitor)} >{exhibitor.company} - {exhibitor.fullName}</option>)})}
            </select>
            <label htmlFor="new-group-event">{t('exhibitor')}</label>
          </div>
          <button className="send-btn">{t('accept')}</button>
        </form>
      </Modal>
      <Modal isActive={infoModal} handle={()=>{}} title="Completar información">
        <form onSubmit={handleInfoSubmit} className="gap-2 flex flex-col mx-auto w-[60%]">
          <div className="input-holder w-full">
            <input type="text" name="position" id="new-info-position" onChange={(e)=>{setNewInfo({...newInfo, position:e.target.value})}} required/>
            <label htmlFor="new-info-position">{t('position')}</label>
          </div>
          <div className="input-holder w-full">
            <input type="text" name="phone" id="new-info-phone" onChange={(e)=>{setNewInfo({...newInfo, phone:e.target.value})}} required/>
            <label htmlFor="new-info-phone">{t('phoneNumber')}</label>
          </div>
          <button className="send-btn mx-auto block mt-2">{t('close')}</button>
        </form>
      </Modal>
      </>
    }
  </>)
}